import { render } from "./StockOutDetailView.vue?vue&type=template&id=3c1ce228&scoped=true"
import script from "./StockOutDetailView.vue?vue&type=script&lang=js"
export * from "./StockOutDetailView.vue?vue&type=script&lang=js"

import "./StockOutDetailView.vue?vue&type=style&index=0&id=3c1ce228&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1ce228"]])

export default __exports__